<template>
  <div class="sidebar">
    <ul class="social">
      <li
        v-for="s in social"
        :key="s.label">
        <a
          :href="s.link"
          :aria-label="s.label"
          target="_blank"
          rel="noopener noreferrer"
          :title="`open ${s.label}`"
        >
          <font-awesome-icon
            :icon="['fab', s.label,]"
            role="presentation"
            :aria-label="s.label" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SocialLinks',
  data () {
    return {
      social: [
        {
          label: 'github',
          link: 'https://github.com/soumyadip001'
        },
        {
          label: 'linkedin',
          link: 'https://www.linkedin.com/in/soumyadip-hazra-4856b8a7/'
        },
        {
          label: 'google',
          link: 'mailto:soumyadiphazra@gmail.com'
        },
        {
          label: 'facebook',
          link: 'https://www.facebook.com/soumyadip.hazra.5'
        },
        {
          label: 'dribbble',
          link: 'https://dribbble.com/iamsdh59'
        }
      ]
    }
  }
}
</script>

<style scoped>
</style>
